import React, { useCallback, useRef, useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { useSnackbar } from "notistack";
import { RiPlayListAddFill } from "react-icons/ri";
import {
  Background,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalWrapper,
  Row,
  Column,
} from "./styles";
import ComplementService from "../../services/complementService";
import Button from "react-bootstrap/Button";

export const ModalSocios = ({
  showModal,
  setShowModal,
  cnpjSelected,
  setRefreshList,
  id_socio,
  nome_socio,
  attributes,
}) => {
  const modalRef = useRef();

  const [complements, setComplements] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };
  
  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    },
    [setShowModal, showModal]
  );

  const handleChange = (event, value = 0) => {
    const newValue = complements;
    newValue[event.target.name] = event.target.value;
    setComplements({ ...newValue });
  };

  const handleSubmit = (publish) => {
    var obj = [];
    var telefone;
    var email;
    var site;

    if (!!complements.tel) {
      telefone = {
        usuario: localStorage.getItem("CODIGO_USUARIO"),
        id_atribute: 2,
        values: [{ value: complements.tel }],
        namecard: "Quadro Societário",
        cnpj: cnpjSelected,
        validated: true,
        id_socio: id_socio,
      };
      obj.push(telefone);
    }

    if (!!complements.email) {
      email = {
        usuario: localStorage.getItem("CODIGO_USUARIO"),
        id_atribute: 3,
        values: [{ value: complements.email }],
        namecard: "Quadro Societário",
        cnpj: cnpjSelected,
        validated: true,
        id_socio: id_socio,
      };
      obj.push(email);
    }

    

    if (!!complements.site) {
      var https = complements.site.includes("https://") || complements.site.includes("http://");
      site = {
        usuario: localStorage.getItem("CODIGO_USUARIO"),
        id_atribute: 4,
        values: https
          ? [{ value: complements.site }]
          : [{ value: "https://" + complements.site }],
        namecard: "Quadro Societário",
        cnpj: cnpjSelected,
        validated: true,
        id_socio: id_socio,
      };
      obj.push(site);
    }

    if (obj.length === 0) {
      return enqueueSnackbar("Nennhum campo preenchido", {
        variant: "info",
      });
    } else {
      return ComplementService.postComplement(obj)
        .then((res) => {
          enqueueSnackbar("Informação complementar adicionada com sucesso!", {
            variant: "success",
          });
          setShowModal(false);
          setComplements([]);
        })
        .catch((error) => {
          enqueueSnackbar("Ocorreu um erro ao adicionar", {
            variant: "error",
          });
        })
        .finally(() => {
          setRefreshList();
        });
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  return (
    <>
      {showModal ? (
        <Background onClick={closeModal} ref={modalRef}>
          <ModalWrapper showModal={showModal}>
            <ModalHeader>
              <button
                onClick={() => setShowModal((prev) => !prev)}
                className="close"
                aria-label="Fechar"
              >
                <span>x</span>
              </button>

              <span className="title">
                <RiPlayListAddFill className="iconeHeader" />
                Informação complementar de <br />
                {nome_socio}
              </span>
            </ModalHeader>
            <ModalBody>
              <hr className="modalseparator" />

              <Row>
                <Column>
                  <form>
                    {attributes.map((attribute) => (
                      <>
                        {attribute.id === 2 && (
                          <>
                            <InputMask
                              id="value"
                              mask="(99) 99999-9999"
                              maskPlaceholder={null}
                              type="tel"
                              className="form-full"
                              placeholder="Telefone"
                              onChange={handleChange}
                              name="tel"
                            ></InputMask>
                          </>
                        )}
                        {attribute.id === 3 && (
                          <>
                            <input
                              id="value"
                              type="email"
                              className="form-full"
                              placeholder="E-mail"
                              onChange={handleChange}
                              name="email"
                            ></input>
                          </>
                        )}
                        {attribute.id === 4 && (
                          <>
                            <input
                              id="value"
                              type="site"
                              className="form-full"
                              placeholder="Site"
                              onChange={handleChange}
                              name="site"
                            ></input>
                          </>
                        )}
                      </>
                    ))}
                  </form>
                </Column>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="none"
                className="buttons"
                onClick={() => handleSubmit()}
              >
                Salvar
              </Button>
            </ModalFooter>
          </ModalWrapper>
        </Background>
      ) : null}
    </>
  );
};
